import { ChainID } from '@ankr.com/chains-list';

import { useChainSelectors } from 'modules/chains/components/ChainSelectorsProvider';
import { isEVMBased } from 'modules/chains/utils/isEVMBased';
import { isMultichain } from 'modules/chains/utils/isMultichain';
import { hasEvmSubchains } from 'modules/chains/utils/hasEvmSubchains';

import { TRON_REST_API_GROUP_ID } from '../constants';
import { useNetworkConfig } from './useNetworkConfig';

export const useCanAddNetwork = () => {
  const { chain, group, isConsensusEnabled } = useChainSelectors();

  const networkConfig = useNetworkConfig({ chain });

  const isTronRestApi =
    chain.id === ChainID.TRON && group.id === TRON_REST_API_GROUP_ID;

  return (
    (isEVMBased(chain.id) || !isTronRestApi || hasEvmSubchains(chain)) &&
    !isConsensusEnabled &&
    !isMultichain(chain.id) &&
    !!networkConfig
  );
};
